import {
  Accessory,
  AccessoryResponse,
  StoreAccessoryRequest,
} from '@/types/accessory';
import { Query } from '@/types/query';
import { PaginatedResponse, Response } from '@/types/response';
import { api } from '@/utils/axios';
import { AxiosResponse } from 'axios';

export const ScanAccessory = async (
  uuid: string,
): Promise<AxiosResponse<AccessoryResponse>> => {
  return await api.get(`/app-web/accessories/${uuid}`);
};

export const StoreAccessory = async (
  accessory: StoreAccessoryRequest,
): Promise<Response<Accessory>> => {
  const response = await api.post('/app-web/accessories', accessory);
  return response.data;
};

export const ListAccessories = async (
  query: Query,
): Promise<Response<Accessory[] | PaginatedResponse<Accessory>>> => {
  const response = await api.get('/app-web/accessories', { params: query });
  return response.data;
};
